<template lang="pug">
v-row
  v-col.pb-0(cols="12")
    filter-autocomplete(
      v-model="formData.location" 
      :getItems="getExamLocation"
      label="Exam Location" 
      :error="formErrors.hasError('location')"
      :error-messages="formErrors.fields.location"
      testName="exam-location"
    )
  v-col.pt-0.pb-0(cols="12")
    fieldDatepicker(
      v-model="formData.date"
      label="Exam Date"
      :error="formErrors.hasError('examDate')"
      :error-messages="formErrors.fields.examDate"
    )
  v-col.pt-0.pb-0(cols="6")
    timepicker(
      :key="`${showing}timeFrom`"
      v-model="formData.timeFrom"
      label="Time from"
      :hide-details="false"
      :error="formErrors.hasError('timeFrom')"
      :error-messages="formErrors.fields.timeFrom"
      data-test="exam-time-from"
    )
  v-col.pt-0.pb-0(cols="6")
    timepicker(
      :key="`${showing}timeFrom`"
      v-model="formData.timeTo"
      label="Time to"
      :hide-details="false"
      :error="formErrors.hasError('timeTo')"
      :error-messages="formErrors.fields.timeTo"
      data-test="exam-time-to"
    )

</template>

<script>
import {mapActions} from "vuex"
import { convertToDefaultBackendFormat } from '../../../../../../util'
export default {
  name: 'ExamBody',
  props: {
    formData: Object,
    formErrors: Object,
    showing: Boolean
  },

  data: () => ({
    currentDate: convertToDefaultBackendFormat (new Date(Date.now())),
  }),

  methods: {
    ...mapActions({
      getExamLocation: 'crmExamLocation/list',
    }),

    updateVal(val, field) {
      this.formData[field] = val
    }
  },

  components: {
    datepicker: () => import('@/app/admin/components/CrmDatepicker.vue'),
    timepicker: () => import('@/components/global/Timepicker.vue'),
    filterAutocomplete: () => import('@/components/global/FilterAutocomplete.vue'),
    fieldDatepicker: () => import('@/components/global/FieldDatepicker.vue')
  }
}
</script>
